import { render } from "./GraphicAddon.vue?vue&type=template&id=e8590754"
import script from "./GraphicAddon.vue?vue&type=script&lang=js"
export * from "./GraphicAddon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__